"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
}
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
}
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_times_1 = __importDefault(require("lodash.times"));
var lodash_zip_1 = __importDefault(require("lodash.zip"));
var JsonParseError_1 = require("./JsonParseError");
var dateUtils = __importStar(require("../utils/DateUtils"));
require("reflect-metadata");
/*tslint:disable no-any*/
var mapperRegister = {};
var clone = function (array) { return array.slice(); };
function registerStringMapper(type, mapper) {
    mapperRegister[getName(type) + "_string"] = mapper;
}
exports.registerStringMapper = registerStringMapper;
function registerNumberMapper(type, mapper) {
    mapperRegister[getName(type) + "_number"] = mapper;
}
exports.registerNumberMapper = registerNumberMapper;
function registerBooleanMapper(type, mapper) {
    mapperRegister[getName(type) + "_boolean"] = mapper;
}
exports.registerBooleanMapper = registerBooleanMapper;
function tryReadField(jsonValue, matchesType, convert, error, validators, propName) {
    if (matchesType(jsonValue)) {
        var value_1 = convert(jsonValue);
        validators.forEach(function (validator) {
            var err = validator(value_1);
            if (err) {
                throw new JsonParseError_1.JsonParseError("Validation failed for property: " + propName + ": " + err, JsonParseError_1.JsonParseErrorCode.VALIDATION_FAILED);
            }
        });
        return value_1;
    }
    throw error();
}
function parseValue(cls, json, spec, prefix, genericTypes, validators) {
    function propName() {
        return prefix + "/" + spec.propName;
    }
    if (spec.optional && (json === undefined || json === null)) {
        return spec.defaultValue;
    }
    var expectedTypeName = getName(cls);
    switch (expectedTypeName) {
        case "String":
            return tryReadField(json, function (fieldValue) { return typeof fieldValue === "string"; }, function (fieldValue) { return fieldValue; }, function () { return new JsonParseError_1.JsonParseError("Expected a string value for property " + propName(), JsonParseError_1.JsonParseErrorCode.INVALID_TYPE); }, validators, propName());
        case "Number":
            return tryReadField(json, function (fieldValue) { return typeof fieldValue === "number"; }, function (fieldValue) { return fieldValue; }, function () { return new JsonParseError_1.JsonParseError("Expected a number value for property " + propName(), JsonParseError_1.JsonParseErrorCode.INVALID_TYPE); }, validators, propName());
        case "Boolean":
            return tryReadField(json, function (fieldValue) { return typeof fieldValue === "boolean"; }, function (fieldValue) { return fieldValue; }, function () { return new JsonParseError_1.JsonParseError("Expected a boolean value for property " + propName(), JsonParseError_1.JsonParseErrorCode.INVALID_TYPE); }, validators, propName());
        case "DateClass":
            var isoRegexp = /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+)|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d)|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d)/;
            var regExp = /(\d{4})-(\d{2})(?:-(\d{2}))/;
            return tryReadField(json, dateUtils.isDateString, dateUtils.parseDate, function () { return new JsonParseError_1.JsonParseError("Expected a Date object for property " + propName(), JsonParseError_1.JsonParseErrorCode.INVALID_TYPE); }, validators, propName());
        case "Array":
            if (!spec.type) {
                throw new JsonParseError_1.JsonParseError("Missing type annotation for array property " + propName(), JsonParseError_1.JsonParseErrorCode.INVALID_TYPE);
            }
            return tryReadField(json, function (fieldValue) { return Array.isArray(fieldValue); }, function (fieldValue) { return fieldValue.map(function (arrayElem, idx) { return parseValue(spec.type, arrayElem, { propName: "[" + idx + "]", optional: false, defaultValue: undefined }, prefix + "/" + spec.propName, genericTypes, validators); }); }, function () { return new JsonParseError_1.JsonParseError("Expected an array for property " + propName(), JsonParseError_1.JsonParseErrorCode.INVALID_TYPE); }, validators, propName());
        default:
            return doParse(cls, json, prefix + "/" + spec.propName, genericTypes);
    }
}
function doParse(cls, json, prefix, genericTypes) {
    var getMetadata = Reflect.getMetadata;
    if (isSimpleType(cls)) {
        return parseValue(cls, json, { propName: "array", type: cls, optional: true, defaultValue: undefined }, prefix, undefined, []);
    }
    var constructorParams = clone(getMetadata("design:paramtypes", cls));
    if (!constructorParams || isRegistrable(cls)) {
        var clsName = getName(cls);
        var mapperKey = clsName + "_" + typeof json;
        if (mapperRegister[mapperKey]) {
            return mapperRegister[mapperKey](json);
        }
        throw new JsonParseError_1.JsonParseError("No mapper defined for types " + clsName + " and " + typeof json, JsonParseError_1.JsonParseErrorCode.INVALID_MODEL_CLASS);
    }
    var jsonProps = lodash_times_1.default(constructorParams.length).map(function (n) { return getMetadata("field:" + n, cls); });
    if (genericTypes) {
        jsonProps.forEach(function (prop, n) {
            var spec = prop;
            if (genericTypes.types[spec.propName] && constructorParams[n] === Object) {
                constructorParams[n] = genericTypes.types[spec.propName];
            }
        });
    }
    var copyParams = getMetadata("design:paramtypes", cls);
    var generics = lodash_times_1.default(constructorParams.length).map(function (n) { return getGenericMetadata(jsonProps, n, cls, getMetadata); });
    var validators = lodash_times_1.default(constructorParams.length).map(function (n) { return getMetadata("validation:" + n, cls); });
    var values = lodash_zip_1.default(jsonProps, constructorParams, generics, validators).map(function (data) {
        var spec = data[0];
        var param = data[1];
        var genericTypes = data[2];
        var validators = data[3];
        if (!spec || !spec.propName) {
            throw new JsonParseError_1.JsonParseError("Missing @Field annotation in type " + getName(cls), JsonParseError_1.JsonParseErrorCode.MISSING_ANNOTATION);
        }
        //support for variant names like "foo | bar | baz"
        var propNames = spec.propName.split("|").map(function (p) { return p.trim(); });
        var innerJson = undefined;
        for (var i = 0; i < propNames.length; i++) {
            if (json.hasOwnProperty(propNames[i])) {
                innerJson = json[propNames[i]];
                break;
            }
        }
        if (!innerJson === undefined && !spec.optional) {
            throw new JsonParseError_1.JsonParseError("Missing property " + spec.propName + " at path " + prefix, JsonParseError_1.JsonParseErrorCode.MISSING_PROPERTY);
        }
        if (spec.rawValue) {
            return innerJson;
        }
        return parseValue(param, innerJson, spec, prefix, genericTypes, validators || []);
    });
    return new (cls.bind.apply(cls, [void 0].concat(values)))();
}
function getGenericMetadata(props, index, cls, getMetadata) {
    if (props && props[index] && props[index].propName) {
        return getMetadata("generic:" + props[index].propName, cls);
    }
}
function getName(cls) {
    var getMetadata = Reflect.getMetadata;
    var sparksonId = getMetadata("sparksonRegistrable", cls);
    if (sparksonId) {
        return sparksonId;
    }
    if (cls["type"]) {
        return cls["type"];
    }
    if (cls["name"]) {
        return cls["name"];
    }
    var funcNameRegex = /function (.{1,})\(/;
    var results = (funcNameRegex).exec(cls.toString());
    return (results && results.length > 1) ? results[1] : "";
}
function isSimpleType(cls) {
    var typeName = getName(cls);
    return typeName === "String" || typeName === "Number" || typeName === "Boolean" || typeName == "DateClass";
}
function isRegistrable(cls) {
    var getMetadata = Reflect.getMetadata;
    var sparksonId = getMetadata("sparksonRegistrable", cls);
    return !!sparksonId;
}
function parse(cls, json) {
    return parseValue(cls, json, { propName: ".", optional: false, defaultValue: undefined }, "", undefined, []);
}
exports.parse = parse;
function parseArray(cls, json, optional) {
    if (optional === void 0) { optional = false; }
    if (json === null && optional) {
        return [];
    }
    return parseValue(Array, json, { propName: ".", optional: optional, type: cls, defaultValue: undefined }, "", undefined, []);
}
exports.parseArray = parseArray;
/*tslint:enable no-any*/
